import { render, staticRenderFns } from "./VehicleInsuranceItem.vue?vue&type=template&id=25b7e95a&scoped=true"
import script from "./VehicleInsuranceItem.vue?vue&type=script&lang=js"
export * from "./VehicleInsuranceItem.vue?vue&type=script&lang=js"
import style0 from "./VehicleInsuranceItem.vue?vue&type=style&index=0&id=25b7e95a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7e95a",
  null
  
)

export default component.exports